import { createFileRoute } from '@tanstack/react-router'
import { BuyerActiveCallsPage } from '@/features/buyer-panel/pages/buyer-active-calls-page'

export const Route = createFileRoute('/_authenticated/buyer-panel/active-calls')({
  component: BuyerActiveCallsPage,
})
